<template>
  <v-app :dark="isDarkMode" app>
    <v-snackbar v-if="newVersion" class="mt-16" color="white" light :timeout="-1" :value="true" absolute middle top>
      <div @click="reload" class="pointer">
        <div class="float-left mt-2 ml-4" color="black">New dashboard version available, please reload!</div>
        <v-btn class="float-left ml-3 mr-0" icon ><v-icon>mdi-reload</v-icon></v-btn>
      </div>
    </v-snackbar>
    <the-sidebar v-if="nav" :nav="nav" />
    <event-log-detail-view :eventLogData="eventLogItem" />
    <portal-target class="right-hand-nav-drawer" name="right-hand-nav-drawer">
    </portal-target>
    <portal-target class="sticky-top" v-if="!isSmallDesktop && $route.path === '/editinterface'" name="sticky-top">
    </portal-target>
    <v-main :style="{ background: $vuetify.theme.themes[theme].background }">
      <the-header />
      <v-container fluid>
        <router-view></router-view>
        <preloader />
      </v-container>
    </v-main>
    <v-footer>
     <v-bottom-navigation
        app
        v-if="!isSmallDesktop"
        v-model="value"
        fixed
        color="white"
        class="bottom-navigation"
      >
        <div class="bottom-navigation__item" @click="$router.push('/dashboard')">
          <span v-if="value === 0" :class="{ 'white--text' : isDarkMode, 'purple--text': !isDarkMode }">Dashboard</span>
          <span v-else :class="{ 'apioshade3--text' : isDarkMode, 'apioshade3--text': !isDarkMode }">Dashboard</span>
          <apio-icon size="32" v-if="value === 0" name="nav-chart" lightModeColour="purple" darkModeColour="white" />
          <apio-icon size="32" v-else name="nav-chart" lightModeColour="apioshade4" darkModeColour="apioshade3" />
        </div>

        <div class="bottom-navigation__item" @click="$router.push('/events-log')">
          <span v-if="value === 1" :class="{ 'white--text' : isDarkMode, 'purple--text': !isDarkMode }">Events Log</span>
          <span v-else :class="{ 'apioshade3--text' : isDarkMode, 'apioshade3--text': !isDarkMode }">Events Log</span>
          <apio-icon size="32" v-if="value === 1" name="nav-layers" lightModeColour="purple" darkModeColour="white" />
          <apio-icon size="32" v-else name="nav-layers" lightModeColour="apioshade4" darkModeColour="apioshade3"  />
        </div>

        <div class="bottom-navigation__item"  @click="$router.push('/status')">
          <span v-if="value === 2" :class="{ 'white--text' : isDarkMode, 'purple--text': !isDarkMode }">Status</span>
          <span v-else  :class="{ 'apioshade3--text' : isDarkMode, 'apioshade3--text': !isDarkMode }">Status</span>
          <apio-icon size="32" v-if="value === 2" name="nav-status" lightModeColour="purple" darkModeColour="white" />
          <apio-icon size="32" v-else name="nav-status" lightModeColour="apioshade4" darkModeColour="apioshade3" />
        </div>

        <div class="bottom-navigation__item"  @click="$router.push('/users')">
          <span v-if="value === 3" :class="{ 'white--text' : isDarkMode, 'purple--text': !isDarkMode }">Users</span>
          <span v-else :class="{ 'apioshade3--text' : isDarkMode, 'apioshade3--text': !isDarkMode }">Users</span>
          <apio-icon size="32" v-if="value === 3" name="ui-user-fill" lightModeColour="purple" darkModeColour="white" />
          <apio-icon size="32" v-else name="ui-user-fill" lightModeColour="apioshade4" darkModeColour="apioshade3" />
        </div>
      </v-bottom-navigation>
    </v-footer>
    <apio-snackbar
      :text="snackBarText"
      :status="snackBarStatus"
      :snackbar="snackbar"
      @close="snackbar = false"
    />
  </v-app>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import request from '@/API/';
import axios from 'axios'; // no accident, not for api server!
import router from "../router";
import { mapState } from "vuex";

const Preloader = () => import("@/components/Preloader/Preloader.vue");

export default {
  name: "TheContainer",
  data: () => ({
    nav: [],
    darkMode: true,
    value: 0,
    eventLogItem: {},
    newVersion: false,
  }),
  components: {
    TheSidebar,
    TheHeader,
    Preloader,
    EventLogDetailView: () => import("@/pages/Events/EventLogDetailView.vue"),
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const { data } = await request.get("/user/m");
      next((instance) => {
        instance.nav = data;
      });
    } catch (err) {
      console.log(err);
      router.push({ path: "/pages/login" });
    }
  },
  computed: {
    ...mapState({
      snackBarText: (state) => state.mode.snackBarText,
      snackBarStatus: (state) => state.mode.snackBarStatus,
      snackbar: (state) => state.mode.snackbar,
    }),
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    isMobile() {
      return this.$vuetify.breakpoint.width < 769;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    darkActiveTextClass() {
      return this.isDarkMode ? "white--text" : "purple--text";
    },
    isSmallDesktop() {
      return this.$vuetify.breakpoint.width > 1024;
    },
  },
  watch: {
    $route() {
   //    console.log('check version');
   //   this.checkVersion();
    },
    isDarkMode() {
      this.isDarkMode
        ? localStorage.setItem("darkMode", true)
        : localStorage.setItem("darkMode", false);
    },
  },
  mounted() {
//    this.checkVersion();
  },
  created() {
    const darkMode = localStorage.getItem("darkMode") == "true" ? true : false;
    if(darkMode) { this.$store.state.mode.darkMode = true }

    if (this.$store.state.mode.darkMode) {
      this.$vuetify.theme.dark = true;
    }
    this.$store.dispatch("fetchUser");
    this.$root.$on("toggleEventLogDetailsView", (item) =>
      this.toggleEventLogDetailsView(item)
    );
  },
  methods: {
    checkVersion() {
      this.newVersion = false
      if (process.env.VUE_APP_BASE_URL == '/') {
        return
      }
      axios.get('/version').then(res => {
        if (res.data != process.env.VUE_APP_VERSION) {
          console.log('version', res.data, process.env.VUE_APP_VERSION)
          if (res.data)
          this.newVersion = true
        }
      }).catch(err => {
        console.log(err)
        this.newVersion = false
      })
    },
    reload() {
      window.location.reload(true);
    },
    toggleEventLogDetailsView() {
      this.eventLogDetailView = !this.eventLogDetailView;
    },
  },
  beforeDestroy() {
    localStorage.removeItem('vuex');
  }
};
</script>

<style scoped lang="scss">
.container {
  padding-left: 0;
  padding-right: 0;
}

.right-hand-nav-drawer {
  z-index: 12 !important;
  min-width: 360px !important;
  width: 360px !important;
}

.bottom-navigation {
  font-size: var(--font-tiny-size);
  &__item {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }
  &__item:not(:last-of-type) {
    margin-right: 40px;
  }

  @media screen and (min-width: 768px) {
    &__item:not(:last-of-type) {
      margin-right: 80px;
    }
  }

  padding-bottom: 4px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.sticky-top {
  padding: 8px 16px;
  width: 100%;
  top: 0;
  position: fixed;
  z-index: 11;
  background-color: rgba(255,255,255,0.92);
  box-shadow: 0 5px 5px -1px #ddd;
}

.pointer {
  cursor: pointer;
}
</style>
